// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1eIv2","range":"MonthRangeSwitch_range__Ki_jN","disabled":"MonthRangeSwitch_disabled___2Pza"};